import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {NgFor, NgSwitch, NgSwitchCase} from '@angular/common';

@Component({
    selector: 'app-info-match-value-on',
    templateUrl: './info-match-value-on.component.html',
    styleUrls: ['./info-match-value-on.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent, NgFor, NgSwitch, NgSwitchCase]
})
export class InfoMatchValueOnComponent implements OnInit {
  // DEPRECATED
  constructor(
    public dialogRef: MatDialogRef<InfoMatchValueOnComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      platform: string,
      matches: string[]
    },
  ) { }

  ngOnInit(): void {
  }

}
